import axios from 'axios';

// API doesn't accept X-CSRF-TOKEN as a header
axios.defaults.headers.common = {
  'Content-Type': 'application/json',
  Accept: 'application/json, text/json, application/xml, text/xml',
};

import { POST_PRODUCT_PRICES } from './mutations';

const actions = {
  [POST_PRODUCT_PRICES]({ commit, state }, productIds) {
    axios.post(state.PRICES_ENDPOINT, productIds).then(({ data }) => {
      commit({ type: POST_PRODUCT_PRICES, payload: data });
    });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/price-range/actions.js